// Navbarheader — updated with SmartSearch (Enter-triggered panel) + NotificationBell
import React, { useEffect, useState } from 'react';
import {
  Box, Typography, IconButton, Avatar, Tooltip,
  Menu, MenuItem, Divider,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import PersonAddAltIcon          from '@mui/icons-material/PersonAddAlt';
import ListAltIcon               from '@mui/icons-material/ListAlt';
import LogoutIcon                from '@mui/icons-material/Logout';
import ChevronRightIcon          from '@mui/icons-material/ChevronRight';

import { Get_All_Sales_Action }        from '../Redux/Actions/SalesAction';
import { Getalldatauserlog_forsearch } from '../Redux/Actions/AuthAction';
import { Logoutsession_one_Device }    from '../Redux/Actions/Devices_Action';
import { Leftsidebare2 }               from '../Utility/Leftsidebare2';
import NotificationBell                from '../Pages/NotificationBell';   // ← موجود
import { SmartSearch }                 from '../Component/SmartSearch';    // ← الجديد

// ─── Tokens ───────────────────────────────────────────────────────────────────
const C = {
  bg:        '#FFFFFF',
  border:    '#EAECF0',
  text:      '#101828',
  textMuted: '#667085',
  accent:    '#1A3ECF',
  accentSoft:'#EEF1FD',
  iconHover: '#F2F4F7',
};

const NAVBAR_HEIGHT     = 64;
const SIDEBAR_EXPANDED  = 242;
const SIDEBAR_COLLAPSED = 64;

const LEADS_ROUTE = {
  Admin:         '/AllLeadsForAdmin',
  Sales:         '/AllLeadsForSales',
  'Team Leader': '/AllLeadsForTeamLeader',
  Manager:       '/LeadsForManagers',
  Accountant:    '/LeadsForAccountant',
  Marketer:      '/ALLLeadsForMarketer',
};

const DATA_CENTER_ROUTE = {
  Admin:         '/AllLeadsForAdminCRMDataQuickNumbers',
  Sales:         '/SalesQuickNumberCRMData',
  'Team Leader': '/TeamLeaderQuickNumbersCRMData',
};

const getInitials = (name = '') =>
  name.split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || 'U';

// ─── Dropdown item ────────────────────────────────────────────────────────────
const DropdownItem = ({ icon, label, onClick, danger }) => (
  <MenuItem onClick={onClick} sx={{
    px:2, py:'9px',
    display:'flex', alignItems:'center', gap:1.5,
    transition:'background 0.15s',
    '&:hover':{ bgcolor: danger ? '#FEF3F2' : '#F9FAFB' },
    '& .icon':{ color: danger ? '#D92D20' : '#667085', display:'flex', alignItems:'center' },
    '&:hover .icon':{ color: danger ? '#B42318' : '#344054' },
  }}>
    <Box className="icon">{icon}</Box>
    <Typography sx={{ flex:1, fontSize:'13.5px', fontWeight:400, fontFamily:"'DM Sans', sans-serif", color: danger ? '#D92D20' : '#344054' }}>
      {label}
    </Typography>
    <ChevronRightIcon sx={{ fontSize:'16px', color: danger ? '#D92D20' : '#D0D5DD' }} />
  </MenuItem>
);

// ─── Main ─────────────────────────────────────────────────────────────────────
export const Navbarheader = ({ setmode, mode }) => {
  const dispatch  = useDispatch();
  const locationn = useLocation();
  const navigate  = useNavigate();

  const [user,            setUser]            = useState(null);
  const [userlogin,       setUserlogin]       = useState(null);
  const [isMobile,        setIsMobile]        = useState(false);
  const [openDrawer,      setOpenDrawer]      = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [menuAnchor,      setMenuAnchor]      = useState(null);
  const [loadinglogout,   setLoadinglogout]   = useState(true);

  const savedDeviceId = localStorage.getItem('_deviceId');

  // ── Load user ─────────────────────────────────────────────────────────────
  useEffect(() => {
    const u = JSON.parse(localStorage.getItem('user') || 'null');
    if (u) { setUser(u); setUserlogin(u); }
  }, []);

  // ── Responsive ────────────────────────────────────────────────────────────
  useEffect(() => {
    const check = () => {
      const mobile = window.innerWidth < 600;
      setIsMobile(mobile);
      setOpenDrawer(!mobile);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  // ── Hide on login/root ────────────────────────────────────────────────────
  useEffect(() => {
    const path = locationn.pathname;
    setOpenDrawer(path !== '/' && path !== '/Login');
  }, [locationn.pathname]);

  // ── Preload data ──────────────────────────────────────────────────────────
  useEffect(() => {
    dispatch(Get_All_Sales_Action());
    dispatch(Getalldatauserlog_forsearch());
  }, []);

  // ── Logout ────────────────────────────────────────────────────────────────
  const logout = async () => {
    setLoadinglogout(true);
    await dispatch(Logoutsession_one_Device(user?.data?._id, savedDeviceId));
    setLoadinglogout(false);
  };

  useEffect(() => {
    if (!loadinglogout) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.setItem('isLoggedIn', 'false');
      window.location.href = '#/';
    }
  }, [loadinglogout]);

  // ── Derived ───────────────────────────────────────────────────────────────
  const role            = user?.data?.role;
  const userName        = user?.data?.name  || 'User';
  const userEmail       = user?.data?.email || '';
  const profileImage    = user?.data?.profileImg
    ? `/UsersImages/${user.data.profileImg.split('/UsersImages/').pop()}`
    : null;
  const leadsRoute      = LEADS_ROUTE[role];
  const dataCenterRoute = DATA_CENTER_ROUTE[role];
  const sidebarW        = sidebarExpanded ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED;

  return (
    <Box sx={{ position:'relative' }}>

      {/* ── Sidebar ── */}
      <Box sx={{ position:'fixed', top:0, left:0, zIndex:1200, height:'100vh' }}>
        <Leftsidebare2
          openDrawer={openDrawer}
          isMobile={isMobile}
          toggleDrawer={() => setOpenDrawer(p => !p)}
          setOpenDrawer={setOpenDrawer}
          setmode={setmode}
          mode={mode}
          onExpandedChange={setSidebarExpanded}
        />
      </Box>

      {/* ── Navbar ── */}
      <Box
        id="navbarr"
        component="header"
        sx={{
          position:'fixed',
          top:0, left:0, right:0,
          zIndex:1100,
          height:`${NAVBAR_HEIGHT}px`,
          bgcolor:C.bg,
          borderBottom:`1px solid ${C.border}`,
          display:'flex',
          alignItems:'center',
          pr:3,
          gap:2,
        }}
      >
        {/* Sidebar width offset */}
        <Box sx={{
          width:`${sidebarW}px`,
          flexShrink:0,
          transition:'width 0.25s cubic-bezier(0.4,0,0.2,1)',
        }} />

        {/* ── SmartSearch
              Admin   → Enter يطلع الـ panel
              Others  → بيبعت لـ localStorage + window event بس
        ── */}
        {role && <SmartSearch role={role} />}

        {/* Spacer */}
        <Box sx={{ flex:1 }} />

        {/* ── Right actions ── */}
        <Box sx={{ display:'flex', alignItems:'center', gap:'2px' }}>

          {/* ── NotificationBell ── */}
          <NotificationBell userId={userlogin?.data?._id} />

          {/* ── Avatar / Account menu ── */}
          <Tooltip title="Account" placement="bottom">
            <IconButton
              onClick={(e) => setMenuAnchor(e.currentTarget)}
              sx={{
                width:36, height:36,
                borderRadius:'8px',
                border:'0.5px solid #EAECF0',
                padding:'3px',
                ml:'4px',
                '&:hover':{ bgcolor:C.iconHover, borderColor:'#D0D5DD' },
                transition:'all 0.15s',
              }}
            >
              {profileImage ? (
                <Avatar src={profileImage} sx={{ width:28, height:28, borderRadius:'6px', fontSize:'11px' }} />
              ) : (
                <Avatar sx={{
                  width:28, height:28, borderRadius:'6px',
                  fontSize:'11px', fontWeight:500,
                  fontFamily:"'DM Sans', sans-serif",
                  bgcolor:C.accentSoft, color:C.accent,
                  letterSpacing:'0.03em',
                }}>
                  {getInitials(userName)}
                </Avatar>
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      {/* ── Dropdown menu ── */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        transformOrigin={{ horizontal:'right', vertical:'top' }}
        anchorOrigin={{ horizontal:'right', vertical:'bottom' }}
        slotProps={{
          paper:{
            elevation:0,
            sx:{
              mt:'8px', minWidth:260,
              borderRadius:'12px',
              border:`1px solid ${C.border}`,
              boxShadow:'0 8px 32px rgba(16,24,40,0.10)',
              overflow:'visible',
              '&::before':{
                content:'""', display:'block', position:'absolute',
                top:-6, right:14, width:11, height:11,
                bgcolor:'#fff', border:`1px solid ${C.border}`,
                borderBottom:'none', borderRight:'none',
                transform:'rotate(45deg)', zIndex:0,
              },
            },
          },
        }}
      >
        {/* Profile header */}
        <Box sx={{ px:2, py:1.5, display:'flex', alignItems:'center', gap:1.5 }}>
          {profileImage ? (
            <Avatar src={profileImage} sx={{ width:38, height:38 }} />
          ) : (
            <Avatar sx={{
              width:38, height:38, fontSize:'13px', fontWeight:700,
              fontFamily:"'DM Sans', sans-serif",
              bgcolor:C.accentSoft, color:C.accent,
            }}>
              {getInitials(userName)}
            </Avatar>
          )}
          <Box sx={{ overflow:'hidden' }}>
            <Typography sx={{ fontSize:'13.5px', fontWeight:600, color:C.text, fontFamily:"'DM Sans', sans-serif", whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
              {userName}
            </Typography>
            <Typography sx={{ fontSize:'12px', color:C.textMuted, fontFamily:"'DM Sans', sans-serif", whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
              {userEmail || role}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor:C.border }} />

        <DropdownItem
          icon={<AccountCircleOutlinedIcon sx={{ fontSize:'17px' }} />}
          label="My Account"
          onClick={() => { setMenuAnchor(null); navigate('/MyAccount'); }}
        />
        {leadsRoute && (
          <DropdownItem
            icon={<ListAltIcon sx={{ fontSize:'17px' }} />}
            label={role === 'Admin' ? 'All Leads' : 'My Leads'}
            onClick={() => { setMenuAnchor(null); navigate(leadsRoute); }}
          />
        )}
        <DropdownItem
          icon={<PersonAddAltIcon sx={{ fontSize:'17px' }} />}
          label="Create New Lead"
          onClick={() => { setMenuAnchor(null); navigate('/addclient'); }}
        />
        {dataCenterRoute && role !== 'Accountant' && (
          <DropdownItem
            icon={<ListAltIcon sx={{ fontSize:'17px' }} />}
            label="Data Center"
            onClick={() => { setMenuAnchor(null); navigate(dataCenterRoute); }}
          />
        )}

        <Divider sx={{ borderColor:C.border, my:'4px' }} />

        <DropdownItem
          icon={<LogoutIcon sx={{ fontSize:'17px' }} />}
          label="Logout"
          danger
          onClick={() => { setMenuAnchor(null); logout(); }}
        />

        <Box sx={{ px:2, py:1, borderTop:`1px solid ${C.border}`, mt:'4px' }}>
          <Typography sx={{ fontSize:'11px', color:C.textMuted, fontFamily:"'DM Sans', sans-serif", textAlign:'center' }}>
            © {new Date().getFullYear()} Realatix CRM
          </Typography>
        </Box>
      </Menu>
    </Box>
  );
};
